<template>
  <div id="mapContainer" style="width: 100%; height: 100vh; position: relative; z-index: 0;"></div>
</template>
<script>
import areaConfig from '@/common/js/range.js'  // 颜色配置函数
export default {
  name: 'myMap',
  props: ['positions', 'type', 'showSit', 'Pzoom', 'center', 'mapStyle'],
  data() {
    return {
      map: null,
      zoom: 16,                 // 当前缩放等级
      sitIndex: null,           // 当前选中的点位 code
      // 用于存储所有覆盖物实例
      iconOverlays: {},         // key: code, value: 图标覆盖物实例
      popOverlays: {},          // key: code, value: 弹窗覆盖物实例
      rPoint: []                ,// 当前可视区域点位（可选，用于性能优化）
      sitImgSrc: require('@/assets/img/sitImg.png'),
      warningSrc: require('@/assets/img/warning.png')
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    // 初始化地图
    initMap() {
      const map = new T.Map('mapContainer')
      map.centerAndZoom(new T.LngLat(this.center.lng, this.center.lat), 14)
      this.map = map

      // 监听缩放结束事件
      map.addEventListener('zoomend', () => {
        const zoom = map.getZoom()
        this.zoom = zoom
        // console.log('当前缩放等级：', zoom)  // 调试用
        // 更新所有图标的显示状态（基于 zoom 改变图标样式）
        this.updateIconsByZoom(zoom)
      })

      // 监听拖拽结束事件
      map.addEventListener('dragend', () => {
        this.lazyPoint()  // 重新计算可视区域点位
      })

      // 初始计算可视区域点位并创建覆盖物
      this.lazyPoint()
    },

    // 懒加载可视区域点位
    lazyPoint() {
      if (!this.map) return
      const bounds = this.map.getBounds()
      const leftBottom = bounds.getSouthWest()
      const rightTop = bounds.getNorthEast()
      const newRPoint = []
      if (this.positions) {
        this.positions.forEach(p => {
          if ((p.lng >= leftBottom.lng && p.lng <= rightTop.lng) &&
              (p.lat >= leftBottom.lat && p.lat <= rightTop.lat)) {
            newRPoint.push(p)
          }
        })
      }
      this.rPoint = newRPoint

      // 清除旧的覆盖物（简单起见，先全部移除再重新添加）
      this.clearOverlays()
      this.createOverlaysForPoints(newRPoint)
    },

    // 清除所有覆盖物
    clearOverlays() {
      if (this.map) {
        Object.values(this.iconOverlays).forEach(overlay => this.map.removeOverLay(overlay))
        Object.values(this.popOverlays).forEach(overlay => this.map.removeOverLay(overlay))
      }
      this.iconOverlays = {}
      this.popOverlays = {}
    },
    updateAllOverlaysType() {
      // 保存当前打开的弹窗对应的点位 code
        const currentOpenCode = this.sitIndex

        // 重新创建可视区域内的所有覆盖物（会清除旧覆盖物，并用最新的 type 重新生成）
        this.lazyPoint()

        // 如果之前有打开的弹窗，重新打开（确保新生成的覆盖物中存在该点位）
        if (currentOpenCode && this.popOverlays[currentOpenCode]) {
          this.showSitInfo(currentOpenCode)
        }
    },
    // 为点位列表创建覆盖物
    createOverlaysForPoints(points) {
      points.forEach(point => {
        // 创建图标覆盖物
        const iconOverlay = this.createIconOverlay(point)
        this.iconOverlays[point.code] = iconOverlay
        this.map.addOverLay(iconOverlay)

        // 创建弹窗覆盖物（默认隐藏）
        const popOverlay = this.createPopOverlay(point)
        this.popOverlays[point.code] = popOverlay
        popOverlay.setVisible(false)  // 初始隐藏
        this.map.addOverLay(popOverlay)
      })
    },

    // 创建图标覆盖物（对应 sitIcon.vue）
    // 创建图标覆盖物（增加 updateType 方法）
        createIconOverlay(point) {
          const that = this
          const lnglat = new T.LngLat(point.lng, point.lat)

          const IconOverlay = T.Overlay.extend({
            initialize: function(lnglat, data) {
              this.lnglat = lnglat
              this.data = data
              this.updateState()
            },
            updateState: function() {
              const zoom = that.zoom
              this.isDot = zoom < 13
              this.showName = !this.isDot && zoom >= 15
            },
            _render: function() {
              if (!this._container) return
              const bgColor = this.data.state !== '在线' ? '#8B8B8B' : that.areaConfig(that.type, this.data[that.type]).color
              if (this.isDot) {
                this._container.innerHTML = `
                  <div style="position:absolute; left:15px; top:15px; width:20px; height:20px; border-radius:50%; background:${bgColor}; display:flex; align-items:center; justify-content:center;">
                    ${this.data.isyujing == 1 ? '<img src="' + that.warningSrc + '" style="width:12px; height:12px;">' : ''}
                  </div>
                `
              } else {
                const showNameText = this.showName ? (this.data.state !== '在线' ? '--' : (this.data[that.type] || '')) : ''
                const paddingClass = this.showName ? '0 12px' : '6px'
                this._container.innerHTML = `
                  <div class="sitIcon" style="position:absolute; left:-12px; top:-12px; border-radius:0.08rem; display:flex;">
                    <div class="left ellipsis" style="line-height:36px; max-width:180px; font-size:14px; height:36px; background:#405891; padding:0 8px; color:white; z-index:103; border-radius:6px 0 0 6px; text-align:center; display:${this.showName ? 'block' : 'none'};">
                      ${this.data.name}
                    </div>
                    <div class="right" style="font-size:16px; white-space:nowrap; font-weight:600; text-align:center; line-height:36px; padding:${paddingClass}; background:${bgColor}; border-radius:6px; color:white; transform:translateX(${this.showName ? '-4px' : '18px,18px'}); z-index:102; display:flex; align-items:center;">
                      ${this.data.isyujing == 1 ? '<img src="' + that.warningSrc + '" style="width:18px;">' : ''}
                      <div style="${this.data.isyujing == 1 ? 'padding-left:5px;' : ''}">${showNameText}</div>
                    </div>
                  </div>
                `
              }
            },
            onAdd: function(map) {
              this.map = map
              const container = document.createElement('div')
              container.style.position = 'absolute'
              container.style.cursor = 'pointer'
              container.style.zIndex = '102'
              container.addEventListener('click', (e) => {
                e.stopPropagation()
                that.showSitInfo(this.data.code)
              })
              this._container = container
              map.getPanes().overlayPane.appendChild(container)
              this._render()
              this.update()
            },
            onRemove: function() {
              if (this._container && this._container.parentNode) {
                this._container.parentNode.removeChild(this._container)
                this.map = null
                this._container = null
              }
            },
            update: function() {
              if (!this.map || !this._container) return
              const pos = this.map.lngLatToLayerPoint(this.lnglat)
              this._container.style.left = (pos.x - 25) + 'px'
              this._container.style.top = (pos.y - 25) + 'px'
            },
            setZoom: function(zoom) {
              const oldIsDot = this.isDot
              const oldShowName = this.showName
              this.updateState()
              if (oldIsDot !== this.isDot || (!this.isDot && oldShowName !== this.showName)) {
                this._render()
              }
            },
            setVisible: function(visible) {
              if (this._container) {
                this._container.style.display = visible ? 'block' : 'none'
              }
            },
            // 新增：更新参数类型
            updateType: function() {
              this._render()
              this.update()
            }
          })

          return new IconOverlay(lnglat, point)
        },

        // 创建弹窗覆盖物（增加 updateType 方法）
        createPopOverlay(point) {
          const that = this
          const lnglat = new T.LngLat(point.lng, point.lat)

          const PopOverlay = T.Overlay.extend({
            initialize: function(lnglat, data) {
              this.lnglat = lnglat
              this.data = data
            },
            onAdd: function(map) {
              this.map = map
              const container = document.createElement('div')
              container.style.position = 'absolute'
              container.style.zIndex = '108'

              const bgColor = this.data.state !== '在线' ? '#8B8B8B' : that.areaConfig(that.type, this.data[that.type]).color
              const valueText = this.data.state === '在线' ? (this.data[that.type] || '--') : '--'

              container.innerHTML = `
                <div class="sitPop" style="width:2.16rem; height:1.76rem; background:#405891; box-shadow:2px 0px 6px 0px rgba(0,21,41,0.35); border-radius:0.06rem; min-width:150px; min-height:125px; position:absolute; color:white; left:50%; transform:translate(-50%,-80%); z-index:108; padding:0.1rem;">
                  <div class="three" style="position:absolute; width:0.2rem; height:0.2rem; bottom:-0.08rem; min-width:15px; min-height:15px; left:50%; transform:translateX(-50%) rotate(-45deg); background:#405891; z-index:-1; border-radius:0.04rem;"></div>
                  <p class="lansile ellipsis" style="display:flex; align-items:center; justify-content:space-between; margin-bottom:0.04rem;">
                    <span class="ellipsis" style="font-size:0.14rem; width:100%;">${this.data.name}</span>
                    <span><i class="iconfont icon-guanbi" style="font-size:14px;color:white; cursor:pointer;">×</i></span>
                  </p>
                  <div class="sitImg" style="width:100%; height:60%; border-radius:0.08rem; overflow:hidden; position:relative; margin-bottom:0.04rem;">
                    <img src="${that.sitImgSrc}" style="width:100%; height:100%; object-fit:cover;">
                    <div class="pop-value-container" style="position:absolute; zIndex:109; border-radius:4px; display:inline-block; padding:4px 10px; textAlign:right; top:8px; left:8px; display:flex; align-items:center; background:${bgColor};">
                      ${this.data.isyujing == 1 ? '<img src="' + that.warningSrc + '" style="width:18px;">' : ''}
                      <div class="pop-value-text" style="${this.data.isyujing == 1 ? 'padding-left:5px;' : ''}">${valueText}</div>
                    </div>
                    ${this.data.url ? `
                      <div class="camera" style="position:absolute; zIndex:109; border-radius:4px; display:inline-block; textAlign:center; top:8px; right:8px; background:rgba(255,255,255,0.3); height:0.4rem; width:0.54rem; font-size:0.24rem; line-height:0.4rem; cursor:pointer;">📹</div>
                    ` : ''}
                  </div>
                  <p class="fansile ellipsis" style="width:100%; margin:0.04rem 0 0 0; font-size:0.12rem; opacity:0.6;">${this.data.address || ''}</p>
                </div>
              `

              const closeBtn = container.querySelector('.icon-guanbi')
              if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                  e.stopPropagation()
                  that.closePop()
                })
              }

              const cameraBtn = container.querySelector('.camera')
              if (cameraBtn) {
                cameraBtn.addEventListener('click', (e) => {
                  e.stopPropagation()
                  if (this.data.url) window.open(this.data.url, '_blank')
                })
              }

              container.style.display = 'none'
              this._container = container
              map.getPanes().overlayPane.appendChild(container)
              this.update()
            },
            onRemove: function() {
              if (this._container && this._container.parentNode) {
                this._container.parentNode.removeChild(this._container)
                this.map = null
                this._container = null
              }
            },
            update: function() {
              if (!this.map || !this._container) return
              const pos = this.map.lngLatToLayerPoint(this.lnglat)
              this._container.style.left = (pos.x - 25) + 'px'
              this._container.style.top = (pos.y - 35) + 'px'
            },
            setVisible: function(visible) {
              if (this._container) this._container.style.display = visible ? 'block' : 'none'
            },
            // 新增：更新弹窗中显示的内容（参数变化时）
            updateType: function() {
              if (!this._container) return
              const bgColor = this.data.state !== '在线' ? '#8B8B8B' : that.areaConfig(that.type, this.data[that.type]).color
              const valueText = this.data.state === '在线' ? (this.data[that.type] || '--') : '--'

              const valueContainer = this._container.querySelector('.pop-value-container')
              if (valueContainer) {
                valueContainer.style.backgroundColor = bgColor
                const valueSpan = valueContainer.querySelector('.pop-value-text')
                if (valueSpan) valueSpan.textContent = valueText
              }
            }
          })

          return new PopOverlay(lnglat, point)
        },

    // 根据缩放更新所有图标样式
    updateIconsByZoom(zoom) {
      Object.values(this.iconOverlays).forEach(overlay => {
        if (overlay.setZoom) overlay.setZoom(zoom)
      })
    },

    // 显示点位详情
    showSitInfo(code) {
      // 隐藏所有弹窗，显示所有图标（根据 sitIndex 控制）
      Object.values(this.iconOverlays).forEach(overlay => overlay.setVisible(true))
      Object.values(this.popOverlays).forEach(overlay => overlay.setVisible(false))

      if (this.popOverlays[code]) {
        this.popOverlays[code].setVisible(true)
        if (this.iconOverlays[code]) {
          this.iconOverlays[code].setVisible(false)  // 隐藏对应图标
        }
      }

      this.sitIndex = code
      const data = this.positions.find(p => p.code === code)
      if (data) {
        this.$emit('setCenter', { lng: data.lng, lat: data.lat })
        this.$emit('showInfo', data)
      }
    },

    // 关闭弹窗
    closePop() {
      if (this.sitIndex) {
        if (this.iconOverlays[this.sitIndex]) {
          this.iconOverlays[this.sitIndex].setVisible(true)
        }
        if (this.popOverlays[this.sitIndex]) {
          this.popOverlays[this.sitIndex].setVisible(false)
        }
      }
      this.sitIndex = null
      this.$emit('clearSit')
    },

    // 颜色配置（代理到导入的函数）
    areaConfig(type, num) {
      return areaConfig(type, num)
    }
  },

  watch: {
    positions() {
      this.lazyPoint()  // 点位数据变化时重新渲染
    },
    zoom(zoom) {
      // 确保不小于最小缩放
      if (zoom <= this.Pzoom) {
        this.zoom = this.Pzoom
      }
      // 缩放变化时重新计算可视区域点位（原逻辑有 lazyPoint）
      this.lazyPoint()
    },
    showSit(val) {
      // 如果父组件控制显示/隐藏弹窗，可以通过更新 sitIndex 实现
      // 这里简单处理：如果 val 为 false，关闭所有弹窗
      if (!val) {
        this.closePop()
      }
    },
    type() {
        this.updateAllOverlaysType()
      }
  },

  created() {
    // 全局事件监听（原逻辑）
    this.$bus.$on('showCenter', (code) => {
      this.showSitInfo(code)
    })
  },

  beforeDestroy() {
    this.$bus.$off('showCenter')
  }
}
</script>
